export const actionTypes = {
  DASHBOARD_REQUEST: 'DASHBOARD_REQUEST',
  DASHBOARD_SUCCESS: 'DASHBOARD_SUCCESS',
  DASHBOARD_FAILURE: 'DASHBOARD_FAILURE',
  DASHBOARD_SUCCESS_TYPE: 'DASHBOARD_SUCCESS_TYPE',
  LATEST_USERS_REQUEST: 'LATEST_USERS_REQUEST',
  LATEST_USERS_SUCCESS: 'LATEST_USERS_SUCCESS',
};
